import { operationInternalEventSelectors } from './../operation-internal-event.selectors'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { Course } from 'src/app/features/course/course'
import { courseActions } from 'src/app/features/course/course.actions'
import { courseSelectors } from 'src/app/features/course/course.selectors'
import { InternalEvent } from 'src/app/features/internal-event/internal-event'
import { internalEventActions } from 'src/app/features/internal-event/internal-event.actions'
import { internalEventSelectors } from 'src/app/features/internal-event/internal-event.selectors'
import { Product } from 'src/app/features/product/product'
import { productActions } from 'src/app/features/product/product.actions'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { Role } from 'src/app/features/role/role'
import { roleActions } from 'src/app/features/role/role.actions'
import { roleSelectors } from 'src/app/features/role/role.selectors'
import { Subscription } from 'src/app/features/subscription/subscription'
import { subscriptionActions } from 'src/app/features/subscription/subscription.actions'
import { subscriptionSelectors } from 'src/app/features/subscription/subscription.selectors'
import { Survey } from 'src/app/features/survey/survey'
import { surveyActions } from 'src/app/features/survey/survey.actions'
import { surveySelectors } from 'src/app/features/survey/survey.selectors'
import {
  getEnumAsArray,
  scrollToFirstInvalidControl
} from 'src/app/shared/until'
import { OperationType } from '../../operation'
import { InternalEventTypes } from '../internal-event-types'

import { OperationInternalEvent } from '../operation-internal-event'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'

@Component({
  selector: 'operation-internal-event-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class OperationInternalEventFormComponent implements OnInit {
  @Output()
  onSubmit = new EventEmitter<any>()
  @Input()
  operationInternalEvent: OperationInternalEvent

  public form: UntypedFormGroup
  public InternalEventTypes = InternalEventTypes
  public OperationTypes = getEnumAsArray(OperationType).filter(
    (operationType) =>
      [OperationType.MEMBER_COMPLETE_PROFILE].includes(operationType.value)
  )
  public internalEvents$: Observable<InternalEvent[]>
  public courses$: Observable<Course[]>
  public products$: Observable<Product[]>
  public surveys$: Observable<Survey[]>
  public subscriptions$: Observable<Subscription[]>
  public roles$: Observable<Role[]>
  public accessRights = AccessRights
  public isLoading$: Observable<boolean>

  constructor(
    private fb: UntypedFormBuilder,
    private elementRef: ElementRef,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.isLoading$ = this.store.select(
      operationInternalEventSelectors.selectIsLoading
    )
    this.internalEvents$ = this.store
      .select(internalEventSelectors.selectAll)
      .pipe(
        map((internalEvents) =>
          internalEvents.filter((internalEvent) =>
            // below are the only valid types at the moment
            [
              InternalEventTypes.MEMBER_LOGIN,
              InternalEventTypes.MEMBER_CREATED,
              InternalEventTypes.SALE_SUCCESS,
              InternalEventTypes.OPEN_ID_CREATED
            ].includes(parseInt(internalEvent.type))
          )
        )
      )

    this.courses$ = this.store.select(courseSelectors.selectAll)
    this.products$ = this.store.select(productSelectors.selectAll)
    this.surveys$ = this.store.select(surveySelectors.selectAll)
    this.subscriptions$ = this.store.select(subscriptionSelectors.selectAll)
    this.roles$ = this.store.select(roleSelectors.selectAll)

    this.store.dispatch(internalEventActions.fetchMany({}))
    //needed for selector
    //this.store.dispatch(productActions.fetchMany({}))
    this.onSearch({ term: '' })
    this.store.dispatch(subscriptionActions.fetchMany({}))
    this.store.dispatch(courseActions.fetchMany({}))
    this.store.dispatch(surveyActions.fetchMany({}))
    this.store.dispatch(roleActions.fetchMany({}))

    this.form = this.fb.group({
      internalEventId: [null, [Validators.required]],
      surveyId: [null, []],
      productId: [null, []],
      subscriptionId: [null, []],
      courseId: [null, []],
      operationType: [null, []],
      roleId: [null, []],
      fromField: [null, []],
      toField: [null, []],
      value: [null, []]
    })
  }

  ngAfterViewInit() {
    if (this.operationInternalEvent) {
      this.form.patchValue(this.operationInternalEvent.params)
    }
  }

  onFormSubmit() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })

      scrollToFirstInvalidControl(this.elementRef, this.notificationService)
      console.log('%cForm is invalid', 'color: red; font-weight: bold;')
      return
    }

    this.onSubmit.emit({
      ...this.form.value,
      params: {
        fromField: this.form.controls.fromField.value,
        toField: this.form.controls.toField.value,
        value: this.form.controls.value.value
      }
    })
  }
  public onSearch(value) {
    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            description: { [CondOperator.CONTAINS_LOW]: value.term }
          }
        })
      })
    )
  }
}
